/**
 * @desc 新品下单-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductOrderResponseDto>
>;
export function request(
  params: API.basics.productOrder.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productOrder/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
